import { ChoiceMenu } from 'components/eventView/filters/ChoiceMenu';
import { EventEntityCategory } from 'components/eventView/pages/eventData';
import { ActionButton } from 'elements/eventView/atomic/ActionButton';
import { ScrollHorizontal } from 'elements/functional/ScrollHorizontal';
import { useAnalytics } from 'libs/utils/site/analytics';
import { sortBy } from 'lodash';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    entityId: string;
    isWide: boolean;
}

export const EntityFilterRow = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const analytics = useAnalytics();
    const { isWide } = props;

    const unsortedCategories =
        props.entityId === 'map'
            ? ctxEventView.mapCategories
            : ctxEventView.otherEntityDefinitions.find((e) => e.id === props.entityId).categories;
    const entityState =
        props.entityId === 'map'
            ? ctxEventView.mapEntityState
            : ctxEventView.entityStates[props.entityId];

    function handleClick(category: EventEntityCategory) {
        analytics.track('event_ui.filter.clicked', {
            id: category.categoryId,
            title: category.title,
            type: 'category'
        });

        entityState.setFilterIds([category.categoryId]);
    }

    const categories = sortBy(unsortedCategories, (e) => e.orderIndex);

    if (!categories.length) {
        return null;
    }

    return (
        <S_EntityFilterRow className={props.className} $isWide={isWide}>
            {isWide && (
                <>
                    <ChoiceMenu
                        selectedIndex={
                            entityState.filterIds == null
                                ? 0
                                : categories.findIndex((category) =>
                                      entityState.filterIds?.includes(category.categoryId)
                                  ) + 1
                        }
                        items={[
                            Localization.ALL,
                            ...categories.map((category) => {
                                return category.title;
                            })
                        ]}
                        onSelected={(index) => {
                            if (index === 0) {
                                entityState.setFilterIds(null);
                            } else {
                                entityState.setFilterIds([categories[index - 1].categoryId]);
                            }
                        }}
                    />
                </>
            )}
            {!isWide && (
                <S_ScrollHorizontal>
                    <S_Buttons $isWide={isWide}>
                        <ActionButton
                            text={Localization.ALL}
                            highlighted={entityState.filterIds == null}
                            onClick={() => {
                                entityState.setFilterIds(null);
                            }}
                        />
                        {categories.map((category) => {
                            return (
                                <ActionButton
                                    key={category.categoryId}
                                    text={category.title}
                                    highlighted={entityState.filterIds?.includes(
                                        category.categoryId
                                    )}
                                    onClick={() => handleClick(category)}
                                />
                            );
                        })}
                    </S_Buttons>
                </S_ScrollHorizontal>
            )}
        </S_EntityFilterRow>
    );
};

const S_EntityFilterRow = styled.div<{ $isWide: boolean }>`
    background: #fafcfe;
    height: 64px;
    display: flex;
    align-items: center;
    ${(props) => {
        if (props.$isWide) {
            return css`
                height: unset;
                background: unset;
                margin: 0 0 50px 0;
            `;
        }
    }}
`;

const S_Buttons = styled.div<{ $isWide: boolean }>`
    display: flex;
    flex-direction: row;
    gap: 10px;
    height: 100%;
    padding: 10px 12px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                flex-wrap: wrap;
            `;
        }
    }}
`;

const S_ScrollHorizontal = styled(ScrollHorizontal)`
    ::-webkit-scrollbar {
        display: none;
    }
`;
